import type { FieldValue } from './types';

interface LinguisticTypeResult {
  id: FieldValue;
  type: FieldValue;
  startTime: FieldValue;
  endTime: FieldValue;
  text: FieldValue;
}

interface ExpressionTypeResult {
  id: FieldValue;
  meta: FieldValue;
  orderNumber: FieldValue;
  ordinal: FieldValue;
  startTime: FieldValue;
  endTime: FieldValue;
  linguistics: LinguisticTypeResult;
}

interface MetaTypeResult {
  id: FieldValue;
  value: FieldValue;
  type: FieldValue;
}

interface TranscriptTypeResult {
  expressions: ExpressionTypeResult;
  meta: MetaTypeResult;
}

interface TranscriptQueryResult {
  query: {
    transcript: {
      __args: {
        assetId: string;
      };
    };
  };
}

export const LinguisticType = (truify: boolean = false): LinguisticTypeResult => ({
  id: truify,
  type: truify,
  startTime: truify,
  endTime: truify,
  text: truify,
});

export const ExpressionType = (truify: boolean = false): ExpressionTypeResult => ({
  id: truify,
  meta: truify,
  orderNumber: truify,
  ordinal: truify,
  startTime: truify,
  endTime: truify,
  linguistics: LinguisticType(truify),
});

export const MetaType = (truify: boolean = false): MetaTypeResult => ({
  id: truify,
  value: truify,
  type: truify,
});

export const TranscriptType = (truify: boolean = false): TranscriptTypeResult => ({
  expressions: {
    ...ExpressionType(truify),
  },
  meta: {
    ...MetaType(truify),
  },
});

export const transcriptQuery = (): TranscriptQueryResult => ({
  query: {
    transcript: {
      __args: {
        assetId: '',
      },
      // ...TranscriptType(truify),
      // transcript: truify,
    },
  },
});
